module.exports = __webpack_public_path__ + "img/B9.8b08b875.svg";